module.exports = __webpack_public_path__ + "static/media/stockhausen_dortineinemanderen_7.0fc40f77.jpeg";